/**
 * 费率设置
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './RateModal.module.scss';
import http from '@/assets/api/http';
import { Col, Modal, Row, Typography, message, Radio, InputNumber } from 'antd';
import { XInputNum } from '@/components/xqxc_ui';
import { regYuanToFen, regFenToYuan } from '@/util/money';

const { Title } = Typography;

const RateModal = ({
    closeModal,
    data
}) => {

    const [loading, setLoading] = useState(false);
    const [platServiceFeeMode, setPlatServiceFeeMode] = useState(data.platServiceFeeMode || 'RATIO');
    const [platServiceFeeValue, setPlatServiceFeeValue] = useState(data.platServiceFeeMode == 'RATIO' ? data.platServiceFeeValue : regFenToYuan(data.platServiceFeeValue));
    const [cityServiceFeeMode, setCityServiceFeeMode] = useState(data.cityServiceFeeMode || 'RATIO');
    const [cityServiceFeeValue, setCityServiceFeeValue] = useState(data.cityServiceFeeMode == 'RATIO' ? data.cityServiceFeeValue : regFenToYuan(data.cityServiceFeeValue));


    const verifyData = () => {
        if (!platServiceFeeValue && platServiceFeeValue !== 0) {
            message.warn('请输入平台服务费比例');
            return false;
        }
        if (!cityServiceFeeValue && cityServiceFeeValue !== 0) {
            message.warn('请输入市级分润比例');
            return false;
        }
        return true;
    };

    const onSubmit = () => {
        if (!verifyData()) {
            return false;
        }
        let formData = {
            companyId: data.companyInfoId,
            platServiceFeeMode,
            platServiceFeeValue,
            cityServiceFeeMode,
            cityServiceFeeValue
        };
        if (formData.platServiceFeeMode == 'AMOUNT') {
            formData.platServiceFeeValue = regYuanToFen(formData.platServiceFeeValue);
        }
        if (formData.cityServiceFeeMode == 'AMOUNT') {
            formData.cityServiceFeeValue = regYuanToFen(formData.cityServiceFeeValue);
        }
        setLoading(true);
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setCompanyPlatRatio', formData, 'POST')
            .then(() => {
                message.success('结算设置操作成功');
                setLoading(false);
                closeModal(true);
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
    };

    const onPlatServiceFeeModeChange = (e) => {
        let val = e.target.value;
        setPlatServiceFeeMode(val);
    };

    const onCityServiceFeeModeChange = (e) => {
        let val = e.target.value;
        setCityServiceFeeMode(val);
    };

    return <Modal
        width={800}
        centered
        title='结算设置'
        open={true}
        confirmLoading={loading}
        bodyStyle={{ paddingRight: '10px' }}
        onOk={onSubmit}
        onCancel={() => closeModal(false)}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        cancelText='取消'
        okText='提交审核'
    >
        <div className={styles.container}>
            <h3>场景：当配送单归属当前运营公司时，设置平台及市级分润</h3>
            <div className={styles.item}>
                <div className={styles.label}><span>*</span>平台服务费比例</div>
                <div className={styles.val}>
                    <Radio.Group onChange={onPlatServiceFeeModeChange} value={platServiceFeeMode}>
                        <Radio value="RATIO">按比例</Radio>
                        <Radio value="AMOUNT">按金额</Radio>
                    </Radio.Group>
                    <div className={styles.row}>
                        <InputNumber
                            style={{ width: 200 }}
                            min={0}
                            max={platServiceFeeMode == 'RATIO' ? 100 : 999999}
                            precision={2}
                            value={platServiceFeeValue}
                            onChange={setPlatServiceFeeValue}
                            placeholder="两位小数"
                            addonAfter={platServiceFeeMode == 'RATIO' ? '%' : '元'}
                        />
                    </div>
                    <p>平台服务费 = {platServiceFeeMode == 'RATIO' ? '配送费(不含小费) * 显示比例' : '显示金额'}</p>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}><span>*</span>市级分润比例</div>
                <div className={styles.val}>
                    <Radio.Group onChange={onCityServiceFeeModeChange} value={cityServiceFeeMode}>
                        <Radio value="RATIO">按比例</Radio>
                        <Radio value="AMOUNT">按金额</Radio>
                    </Radio.Group>
                    <div className={styles.row}>
                        <InputNumber
                            style={{ width: 200 }}
                            min={0}
                            max={cityServiceFeeMode == 'RATIO' ? 100 : 999999}
                            precision={2}
                            value={cityServiceFeeValue}
                            onChange={setCityServiceFeeValue}
                            placeholder="两位小数"
                            addonAfter={cityServiceFeeMode == 'RATIO' ? '%' : '元'}
                        />
                    </div>
                    <p>市级分润 = {cityServiceFeeMode == 'RATIO' ? '平台服务费 * 显示比例' : '显示金额'}</p>
                </div>
            </div>
            <div className={styles.tips}>注：提交审核通过后生效</div>
        </div>
    </Modal>;
};

RateModal.propTypes = {
    closeModal: PropTypes.func,
    data: PropTypes.object
};
export default RateModal;
